import { ITransactionData } from './Table';

export const transactions = (): ITransactionData[] => [];
